module.exports = __webpack_public_path__ + "img/N1.326370ba.png";